const validPage = (value) => {
  const page = Number(value);
  return Number.isInteger(page) && page > 0 ? page : null;
};

const pageFromLegacyUrl = (url) => {
  if (typeof url !== "string" || !url) return null;

  try {
    return validPage(new URL(url, "https://campaign-list.invalid").searchParams.get("page"));
  } catch (_error) {
    return null;
  }
};

const queryValueFromLegacyUrl = (url, name) => {
  if (typeof url !== "string" || !url) return null;

  try {
    return new URL(url, "https://campaign-list.invalid").searchParams.get(name);
  } catch (_error) {
    return null;
  }
};

const validListLimit = (value) => {
  const limit = Number(value);
  return Number.isInteger(limit) && limit >= 1 && limit <= 100 ? limit : null;
};

export const buildCampaignViewRequest = (route, values = {}) => {
  const page = validPage(values.page) || pageFromLegacyUrl(values.next_page_url);
  const clientId = validPage(values.id);

  return {
    url: `${route}${page ? `?page=${page}` : ""}`,
    body: clientId ? { id: clientId } : {},
  };
};

export const buildAppointmentCampaignListRequest = (values = {}) => {
  const page = validPage(values.page) || pageFromLegacyUrl(values.next_page_url) || 1;
  const limit =
    validListLimit(values.limit) ||
    validListLimit(queryValueFromLegacyUrl(values.next_page_url, "limit")) ||
    30;

  return {
    url: `afterlogin/appointmentcampaign/view?page=${page}&limit=${limit}`,
    body: {
      pagination: true,
      limit,
      ...(typeof values.appointment_type === "string" && values.appointment_type
        ? { appointment_type: values.appointment_type }
        : {}),
    },
  };
};

export const buildCampaignOptionRequest = (route, values = {}) => {
  const requestedPage = validPage(values.page) || pageFromLegacyUrl(values.next_page_url);
  const requestedLimit =
    validListLimit(values.limit) ||
    validListLimit(queryValueFromLegacyUrl(values.next_page_url, "limit"));
  if (!requestedPage && !requestedLimit) {
    const body = {};
    if (typeof values.q === "string" && values.q) body.q = values.q;
    if (values.sort && typeof values.sort === "object") body.sort = values.sort;
    return { url: route, body };
  }
  const page = requestedPage || 1;
  const limit =
    requestedLimit || 10;
  const body = { pagination: true, limit };
  if (typeof values.q === "string" && values.q) body.q = values.q;
  if (values.sort && typeof values.sort === "object") body.sort = values.sort;

  return { url: `${route}?page=${page}&limit=${limit}`, body };
};

const positiveIntegerFromValuesOrLegacyUrl = (values, key) =>
  validPage(values[key]) || validPage(queryValueFromLegacyUrl(values.next_page_url, key));

export const isContentReferenceListRequest = (values = {}) => {
  const id = validPage(values.id);
  return !id && !(values.option && typeof values.option === "object");
};

export const buildContentReferenceViewRequest = (
  route,
  values = {},
  { parentKeys = [], defaultLimit = 10 } = {},
) => {
  const id = validPage(values.id);
  if (id) return { url: route, body: { id } };

  if (values.option && typeof values.option === "object") {
    return { url: route, body: { option: values.option } };
  }

  const page = validPage(values.page) || pageFromLegacyUrl(values.next_page_url) || 1;
  const limit =
    validListLimit(values.limit) ||
    validListLimit(queryValueFromLegacyUrl(values.next_page_url, "limit")) ||
    defaultLimit;
  const body = { pagination: true, limit };

  parentKeys.forEach((key) => {
    const value = positiveIntegerFromValuesOrLegacyUrl(values, key);
    if (value) body[key] = value;
  });
  if (values.sort && typeof values.sort === "object") body.sort = values.sort;
  if (typeof values.field === "string" && values.field) body.field = values.field;
  if (typeof values.q === "string" && values.q) {
    body.apicall = "suggetion";
    body.q = values.q;
  }

  return { url: `${route}?page=${page}&limit=${limit}`, body };
};

export const normalizeContentReferenceListResponse = (response) => {
  if (!Array.isArray(response) && response && Array.isArray(response.data)) return response;

  const rows = Array.isArray(response) ? response : [];
  return {
    current_page: 1,
    data: rows,
    last_page: 1,
    next_page_url: null,
    per_page: rows.length,
    prev_page_url: null,
    total: rows.length,
  };
};

export const normalizeCampaignViewResponse = (response) => {
  if (!Array.isArray(response) && response && Array.isArray(response.data)) return response;

  const campaigns = Array.isArray(response) ? response : [response];
  return {
    current_page: 1,
    data: campaigns,
    last_page: 1,
    next_page_url: null,
    per_page: campaigns.length,
    prev_page_url: null,
    total: campaigns.length,
  };
};

export const mergeCampaignViewPage = (previous, next) => {
  const previousPage = previous && Number(previous.current_page);
  const nextPage = next && Number(next.current_page);
  const previousData = previous && Array.isArray(previous.data) ? previous.data : [];
  const nextData = next && Array.isArray(next.data) ? next.data : [];

  return previousPage && nextPage && nextPage > previousPage
    ? { ...next, data: [...previousData, ...nextData] }
    : next;
};
